import api from '../../../auth/apiClient';
import { getHarvestForemanEndpoint } from '../../harvest-monitoring-foreman/apiConfig';
import type { HarvestForemanMapResponse, HarvestMonitoringFilters } from '../types';

export class HarvestMapService {
    /**
     * Fetch harvest monitoring data grouped by foreman group (kemandoran) for map rendering.
     */
    static async getHarvestMapData(filters: HarvestMonitoringFilters): Promise<HarvestForemanMapResponse> {
        const endpoint = getHarvestForemanEndpoint('MONITORING_FOREMAN');

        // allowed_divisions is only used for legacy FE filtering; pass the rest.
        const { allowed_divisions, ...apiParams } = filters;

        const response = await api.get<HarvestForemanMapResponse>(endpoint, {
            params: apiParams,
        });
        return response.data;
    }
}
